import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useRecallSignEntry } from "../mutate-hooks/use-recall-sign-entry";

export const useRecallSignEntryModal = (
  sectionOneId: string,
  search?: string,
) => {
  const { mutate: recallEntry } = useRecallSignEntry(sectionOneId, search);

  const handleRecall = ({
    sectionOneListId,
    itemNoVersionId,
  }: {
    sectionOneListId: string;
    itemNoVersionId: string;
  }) => {
    recallEntry(
      {
        params: {
          path: {
            sectionOneListId,
            itemNoVersionId,
          },
        },
      },
      {
        onSuccess: () => {
          notification.success({ message: NOTIFICATION_MESSAGES.ENTRY_RECALLED_SUCCESS }); // "Запись отозвана"
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
        },
        onError: () => {
          notification.error({ message: NOTIFICATION_MESSAGES.ENTRY_REJECT_ERROR }); // "Ошибка при отклонении"
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
        },
      },
    );
  };

  return { handleRecall };
};

